.login-to-account {
  margin-bottom: $space-09;

  @include agl-ds-screen-size('medium') {
    margin-bottom: $space-15;
  }

  &__mid-text {
    margin-bottom: 20px;

    @include agl-ds-screen-size('medium') {
      margin-bottom: $space-03;
    }
  }

  &__cta {
    max-width: 376px;
    text-align: center;

    @include agl-ds-screen-size('medium') {
      max-width: 255px;
    }
  }
}
